import { useDisclosure } from '@/hooks';
import { Button, notification } from 'antd';
import React from 'react';
import ReplicateWorkorderComplementModal from './ReplicateComplementModal';
import { useReplicateWorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { ComplementReplicateRequest } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';

const ReplicateComplementButton: React.FC = () => {
  const [modalOpened, modalAction] = useDisclosure();

  const replicateWorkOrder = useReplicateWorkOrder();

  const handleCreateWorkOrder = async (obj: ComplementReplicateRequest) => {
    if (obj) {
      const response = await replicateWorkOrder.mutateAsync(obj);

      notification.success({ message: 'O.S replicada com sucesso!' });

      setTimeout(() => {
        window.open(
          `/app/movements/workOrders/${response.workOrderId}/complements/${response.workOrderComplementId}/generalInfo`,
          '_blank',
        );
      }, 1000);
    }
  };

  return (
    <>
      <Button block onClick={modalAction.open}>
        Replicar O.S
      </Button>

      <ReplicateWorkorderComplementModal
        confirmLoading={replicateWorkOrder.isLoading}
        open={modalOpened}
        onCancel={modalAction.close}
        onOk={handleCreateWorkOrder}
      />
    </>
  );
};

export default ReplicateComplementButton;
